import { render } from "./index.vue?vue&type=template&id=2e7850ad"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabTheme/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e7850ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e7850ad', __exports__)) {
    console.log('reload')
    api.reload('2e7850ad', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2e7850ad", () => {
    console.log('re-render')
    api.rerender('2e7850ad', render)
  })

}


export default __exports__